module.exports = __webpack_public_path__ + "media/images/icons/document-677963ffd9db383d1fccc9166c3785e5.svg";